export const FEATURED_LEAGUES_QUERY_KEY = 'featured-leagues';
export const MLP_STRIP_QUERY_KEY = 'mlp-strip';
export const SCORE_FORMATS_QUERY_KEY = 'score-formats';
export const PLAYER_GRAPH_STATS_QUERY_KEY = 'player-graph-stats';
export const PLAYER_OVERALL_STATS_QUERY_KEY = 'player-overall-stats';
export const PARTNERS_OPPONENTS_STATS_QUERY_KEY = 'partners-opponents-stats';
export const TEAM_PLAYERS_QUERY_KEY = 'team-players';
export const PLAYER_ACTIVITY_QUERY_KEY = 'playerActivity';
export const ACTIVE_TEAMS_QUERY_KEY = 'active-teams';
export const INVITATION_CODE_QUERY_KEY = 'invitation-code';
export const DISTRICTS_INFO_QUERY_KEY = 'districts-info';
export const SYSTEM_USERS_SEARCH_QUERY_KEY = 'system-users-search';
export const SEASON_DIVISION_SUBSTITUTE_PLAYERS_QUERY_KEY = 'season-division-substitute-players';
export const SCHEDULED_EVENTS_QUERY_KEY = 'scheduled-events';
export const TEAM_LEAGUE_MODULE_FOR = 120;
export const TEAM_LEAGUE_DIVISION_MODULE_FOR = 141;
export const TOTAL_TEAM_LEAGUES = 'total-team-leagues';
